import React from "react";
import { Resource } from "react-admin";
import { Route } from "react-router-dom";
import { deviationsResource } from "resources/deviations";

import { CompanySettingsPage } from "../../pages/settings/";
import { pricelistArticlesResource } from "../../resources/customer-pricelist-articles";
import { deviationsRoutes } from "../../resources/deviations/deviations_routes";
import Messages from "../../resources/messages/List/List";
import {
	OrderCreateByCustomer,
	OrderEditByCustomer,
	commonOrdersResourceData,
	ordersResource,
} from "../../resources/orders/";
import { OrdersMultipleChangesPage } from "../../resources/orders/MultipleChanges2";
// import { customerCompaniesResource } from '../../resources/customer-companies/';
import { pricelistHolidaysResource } from "../../resources/pricelist-holidays/";
import { authenticatedResources } from "./authenticated";

export const customerEmployeeResources = [
	<Resource
		name="orders"
		{...ordersResource}
		edit={OrderEditByCustomer}
		create={OrderCreateByCustomer}
	/>,
	<Resource name="draft-orders" {...commonOrdersResourceData} />,
	<Resource {...deviationsResource} name="deviations" />,
	<Resource {...pricelistArticlesResource} name="customer-pricelist-articles" />,
	<Resource {...pricelistHolidaysResource} name="pricelist-holidays" />,
	<Resource name="ports" intent="registration" />,
	<Resource name="areas" intent="registration" />,
	<Resource name="users" intent="registration" />,
	<Resource name="order-statuses" intent="registration" />,
	<Resource name="deviation-statuses" intent="registration" />,
	<Resource name="outgoing-doc-statuses" intent="registration" />,
	<Resource name="cooler-types" intent="registration" />,
	<Resource name="order-pricelist" intent="registration" />,
	<Resource name="drivers" intent="registration" />,
	<Resource name="transporters" intent="registration" />,
	<Resource name="customer-companies" intent="registration" />,
	<Resource name="trucks" intent="registration" />,
	<Resource name="trailers" intent="registration" />,
	<Resource name="terminal" intent="registration" />,
	<Resource name="external-terminal-links" intent="registration" />,
	<Resource name="commodities" intent="registration" />,
	<Resource name="product-articles" intent="registration" />,
	<Resource name="order-product-articles" intent="registration" />,
	<Resource name="pallets-and-boxes" intent="registration" />,
	<Resource name="pallets" intent="registration" />,
	<Resource name="mappers" intent="registration" />,
	<Resource name="product-numbers" intent="registration" />,
	<Resource name="product-names" intent="registration" />,
	<Resource name="automatic-pallets-reservation" intent="registration" />,

	...authenticatedResources,
];

export const customerEmployeeRoutes = [
	deviationsRoutes.edit,
	<Route exact path="/messages" component={Messages} />,
	<Route exact path="/orders/multiple-changes" component={OrdersMultipleChangesPage} />,
	<Route exact path="/draft-orders/multiple-changes" component={OrdersMultipleChangesPage} />,
];
